import { path } from 'ramda';

type Params = { row: object; field: string };

export const nestedFieldValueGetter = ({ row, field }: Params) =>
  path(field.split('.'), row);
